module.exports = __webpack_public_path__ + "img/edit.71fb7062.svg";